module.exports = __webpack_public_path__ + "img/search.bf00e895.svg";